import $ from 'jquery';

export function getTimeRemaining() {
  const endtime = new Date();
  const day = endtime.getDay();

  if (day == 0 || day == 6) {
    return {
      total: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  if (day == 5) {
    endtime.setHours(14, 0, 0, 0);
  } else {
    endtime.setHours(16, 0, 0, 0);
  }
  const total = Date.parse(endtime) - Date.parse(new Date());

  if (total <= 0 && day >= 1 && day <= 4) {
    return {
      total: 0,
      remainingDay: 'Tomorrow',
    };
  }

  // If it's past Friday, return "Monday"
  if (day == 5 && total <= 0) {
    return {
      total: 0,
      remainingDay: 'Monday',
    };
  }
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);

  return {
    total,
    hours,
    minutes,
    seconds,
  };
}

$(() => {
  let timeInterval;

  function setTimeRemaining() {
    const t = getTimeRemaining();

    if (t.total <= 0) {
      $('#timeRemaining').html(
        'Next Day or Standard Delivery available via Parcelforce or Royal Mail.',
      );
      clearInterval(timeInterval);
      return;
    }
    $('.timer-cards').removeClass('d-none');
    $('#timeRemaining strong').text(
      `${t.hours} hours ${t.minutes} min ${t.seconds} seconds  remaining `,
    );
    $('#time-card-hours ').text(
      t.hours,
    );
    $('#time-card-mins ').text(
      t.minutes,
    );
    $('#time-card-secs ').text(
      t.seconds,
    );
  }
  setTimeRemaining();
  timeInterval = setInterval(setTimeRemaining, 1000);
});
